import { Box } from "@mui/material";
import BlogHead from "components/CMS/BlogHead";
import components from "components/CMS/MDXComponents";
import { MDXRemote } from "next-mdx-remote";
import Image from "next/image";
import * as React from "react";
import SecondarySide from "./secondarySide";

export default function BlogDetail({ blog }): React.ReactElement {
  return (
    <React.Fragment>
      {/* <SocialShare blog={blog} /> */}
      <Box
        sx={{
          maxWidth: "1100px",
          mx: "auto",
          px: 2,
        }}
      >
        <BlogHead blog={blog} />
      </Box>
      <Box
        sx={{
          display: "flex",
          maxWidth: "1100px",
          mx: "auto",
          pb: 6,
          flexDirection: {
            xs: "column",
            md: "row",
          },
        }}
      >
        <Box
          component="article"
          className="flex flex-col items-start justify-center flex-1 mb-16 px-4"
          sx={{
            width: {
              xs: "100%",
              md: 0,
            },
          }}
        >
          <div className="w-full prose dark:prose-dark max-w-none">
            <div className="relative h-[450px] mb-8">
              <Image
                src={blog.coverImage + "?w=800"}
                alt={blog.title.toLocaleLowerCase()}
                layout="fill"
                objectFit="cover"
                unoptimized={true}
              />
            </div>
            <MDXRemote
              {...blog.content}
              components={
                {
                  ...components,
                } as any
              }
            />
          </div>
        </Box>
        <Box
          sx={{
            width: {
              xs: "100%",
              md: 320,
            },
            maxWidth: 500,
            mt: 0.5,
            mx: {
              xs: 0,
              md: 2,
            },
            px: {
              xs: 2,
              md: 0,
            },
          }}
        >
          <SecondarySide blog={blog} />
        </Box>
      </Box>
    </React.Fragment>
  );
}
